import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService, ProjectStore, RdxContextStore, RdxContextType, SessionRepository, SystemStore } from '@frontend-site/shared/core';
import { ProjectInfo, System, SystemDetails } from '@frontend-site/shared/data';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LastPageResolverForesightService {
    constructor(
        private systemStore: SystemStore,
        private rdxContextStore: RdxContextStore,
        private projectService: ProjectService,
        private projectStore: ProjectStore,
        private sessionStore: SessionRepository,
        private router: Router
    ) {}

    public resolveForesightSystem(foresightSystem: System): Observable<boolean> {
        return this.systemStore.systemsDetails$.pipe(
            switchMap((systemsDetails: SystemDetails[]) => this.projectService.loadProjectDetails(systemsDetails[0].projectId)),
            tap(() =>
                this.rdxContextStore.updateContext(this.projectStore.projectId, RdxContextType.PROJECT, this.sessionStore.applicationConfig)
            ),
            map((projectInfo: ProjectInfo) => this.getUrlToNavigate(projectInfo, foresightSystem)),
            switchMap((urlToNavigate: string) => this.router.navigateByUrl(urlToNavigate))
        );
    }

    private getUrlToNavigate(projectInfo: ProjectInfo, foresightSystem: System): string {
        let urlToNavigate: string;
        if (!this.hasExtraction(projectInfo)) {
            urlToNavigate = this.getSfAuthenticationUrl(foresightSystem);
        } else {
            urlToNavigate = this.getSfDiscoveryUrl(projectInfo);
        }
        return urlToNavigate;
    }

    private hasExtraction(projectInfo: ProjectInfo): boolean {
        return !!projectInfo.activeEtlId;
    }

    private getSfDiscoveryUrl(projectInfo: ProjectInfo): string {
        return `/foresight/${projectInfo.projectId}`;
    }

    private getSfAuthenticationUrl(system: System): string {
        return `/systemSetup/${system.id}/salesforceSetup`;
    }
}
